import { useState } from "react";
import { adminApi, formatApiError } from "../../lib/adminApi";

const AdminLogin = ({ onLogin }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const { data } = await adminApi.post("/auth/login", { email, password });
            localStorage.setItem("lolopets_token", data.token);
            onLogin(data.user);
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login" className="flex min-h-screen items-center justify-center bg-white px-4">
            <form
                onSubmit={submit}
                className="w-full max-w-sm rounded-2xl border border-black/10 bg-white p-8 shadow-soft"
            >
                <img src="/assets/logo-lolopets-filled.png" alt="LoloPets" className="mx-auto h-16 w-auto" />
                <h1 className="mt-6 text-center font-display text-2xl font-bold text-brand-ink">
                    Panel de administración
                </h1>
                <p className="mt-1 text-center text-sm text-brand-muted">Ingresa con tu cuenta de administrador</p>
                <label className="mt-6 block text-sm font-semibold text-brand-ink" htmlFor="admin-email">
                    Correo
                </label>
                <input
                    id="admin-email"
                    data-testid="admin-login-email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="mt-1.5 min-h-[44px] w-full rounded-xl border border-black/15 px-4 text-base outline-none transition-colors focus:border-brand-magenta"
                    autoComplete="email"
                />
                <label className="mt-4 block text-sm font-semibold text-brand-ink" htmlFor="admin-password">
                    Contraseña
                </label>
                <input
                    id="admin-password"
                    data-testid="admin-login-password"
                    type="password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="mt-1.5 min-h-[44px] w-full rounded-xl border border-black/15 px-4 text-base outline-none transition-colors focus:border-brand-magenta"
                    autoComplete="current-password"
                />
                {error && (
                    <p data-testid="admin-login-error" className="mt-4 rounded-xl bg-brand-magenta/10 px-4 py-3 text-sm font-medium text-brand-magenta">
                        {error}
                    </p>
                )}
                <button
                    data-testid="admin-login-submit"
                    type="submit"
                    disabled={loading}
                    className="mt-6 min-h-[44px] w-full rounded-full bg-brand-magenta font-display font-semibold text-white transition-all duration-300 hover:bg-brand-magentadark disabled:opacity-60"
                >
                    {loading ? "Ingresando..." : "Ingresar"}
                </button>
                <a href="/" data-testid="admin-back-home" className="mt-4 block text-center text-sm font-medium text-brand-muted hover:text-brand-ink">
                    ← Volver al sitio
                </a>
            </form>
        </div>
    );
};

export default AdminLogin;
